/**
 * @generated SignedSource<<18692f52a0aeb4e3363b33a170e4d646>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type superSplashLargeHomeV2LiveWidget$data = {
  readonly label: string | null | undefined;
  readonly relatedArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"homeSuperSplashLargePrimaryV2ContentItemContent" | "homeSuperSplashLargeSecondaryV2ContentItemContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "superSplashLargeHomeV2LiveWidget";
};
export type superSplashLargeHomeV2LiveWidget$key = {
  readonly " $data"?: superSplashLargeHomeV2LiveWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"superSplashLargeHomeV2LiveWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "superSplashLargeHomeV2LiveWidget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "relatedArticles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "homeSuperSplashLargePrimaryV2ContentItemContent"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "homeSuperSplashLargeSecondaryV2ContentItemContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveWidget",
  "abstractKey": null
};

(node as any).hash = "9591d63cd51c4d3f639490f7030853fd";

export default node;
